import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import StylesUtils from '../../res/styles/stylesUtils'
import StringUtils from '../../inumet_js_lib/utils/stringUtils'

import './faIcon.css'

function FAIcon(props) {
    const [, setShowHint] = useState(false)
    const target = useRef(null)

    let fas = props.fas ? 'fas' : ''
    let iconId = props.iconId
    let styleIcon = props.iconStyle ? { ...props.iconStyle } : {}
    if (props.color) {
        styleIcon.color = props.color
    }
    let size = ''
    if (props.size && props.size > 1) {
        size = 'fa-' + (props.size ? props.size : '') + 'x'
    }
    let verticalCenterClass = props.verticalCenter
        ? ' justify-content-center align-self-center'
        : ''
    let marginClasses = StylesUtils.getMarginClasses(
        props.mt,
        props.mr,
        props.mb,
        props.ml
    )

    let resIcon = (
        <i
            ref={target}
            onClick={() => {
                if (props.textOnHover) setShowHint(true)
            }}
            onMouseOver={() => {
                if (props.textOnHover) setShowHint(true)
            }}
            onMouseLeave={() => {
                if (props.textOnHover) {
                    setShowHint(false)
                }
            }}
            style={styleIcon}
            className={`${fas} fa-${iconId} ${size} ${marginClasses} ${verticalCenterClass}`}
        />
    )
    if (StringUtils.notNullNotEmpty(props.textOnHover)) {
        return (
            <OverlayTrigger
                key={'helpHint'}
                placement={'right'}
                overlay={
                    <Tooltip className="ml-2" id="iconId">
                        {props.textOnHover}
                    </Tooltip>
                }
            >
                {resIcon}
            </OverlayTrigger>
        )
    }
    return resIcon
}

FAIcon.propTypes = {
    fas: PropTypes.bool,
    iconId: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
    mt: PropTypes.number,
    ml: PropTypes.number,
    mr: PropTypes.number,
    mb: PropTypes.number,
    verticalCenter: PropTypes.bool,
    textOnHover: PropTypes.string,
    iconStyle: PropTypes.object,
}

export { FAIcon as default }
